import React from 'react'
import classnames from 'classnames/bind'
import type { ReoOffer } from '@adc/sdk/types'
import {
  GRAPH_API_FRAGMENT_DEFINITION,
  GRAPH_API_FRAGMENT_REFERENCE,
} from '../../utils/symbols'
import WorkflowDetails from './WorkflowDetails'
// @ts-ignore
import styles from './styles.scss'

const cx = classnames.bind(styles)

interface FragmentMeta {
  [GRAPH_API_FRAGMENT_DEFINITION]: string
  [GRAPH_API_FRAGMENT_REFERENCE]: string
}

interface ClosingStandardWorkflowProps {
  closing: ReoOffer
}

interface ClosingStandardWorkflowComponent
  extends React.FC<ClosingStandardWorkflowProps> {
  ReoOfferWorkflowFragment: FragmentMeta
}

const ClosingStandardWorkflow: ClosingStandardWorkflowComponent = ({
  closing,
}) => {
  const groups = closing.workflow?.task_groups || []
  const offerWorkflowStatus =
    closing.workflow?.offer_workflow_status ?? 'Upcoming'
  return (
    <div className={cx('milestones-container')}>
      {groups.map(group => (
        <WorkflowDetails
          key={group.code}
          group={group}
          offerWorkflowStatus={offerWorkflowStatus}
          closing={closing}
        />
      ))}
    </div>
  )
}

const WORKFLOW_FRAGMENT = `
  fragment ReoOfferWorkflowDetails on ReoOffer {
    workflow {
      task_groups {
        code
        label
        description
        tooltip_label
        status
        tasks {
          code
          label
          status
          completed_date
          last_updated_date
        }
      }
      offer_workflow_status
    }
  }
`

ClosingStandardWorkflow.ReoOfferWorkflowFragment = {
  [GRAPH_API_FRAGMENT_DEFINITION]: WORKFLOW_FRAGMENT,
  [GRAPH_API_FRAGMENT_REFERENCE]: `...ReoOfferWorkflowDetails`,
}

export default ClosingStandardWorkflow
